module.exports = __webpack_public_path__ + "static/media/TA272_0.b98a41c9.png";